import OperationalReportQuick from './OperationalReportQuick';

export default OperationalReportQuick;
